// Крестик отказа в стиле галочки успеха: два штриха выводятся по очереди,
// как карандашом, и чуть неровные. `pathLength="1"` даёт длину штриха в
// единицах, поэтому dash считается без измерения пути.
const DRAW_CSS = `
@keyframes cross-draw { from { stroke-dashoffset: 1 } to { stroke-dashoffset: 0 } }
.cross-draw { stroke-dasharray: 1; animation: cross-draw 0.9s cubic-bezier(0.65, 0, 0.35, 1) both }
.cross-draw-2 { animation-delay: 0.95s }
@media (prefers-reduced-motion: reduce) { .cross-draw { animation: none; stroke-dashoffset: 0 } }
`

const STROKE = {
  stroke: 'url(#payment-cross-gradient)',
  strokeWidth: 20,
  strokeLinejoin: 'round' as const,
}

/** Декоративный: смысл несёт подпись рядом. */
export const PaymentCross = () => (
  <svg width="114" height="114" viewBox="0 0 114 114" fill="none" aria-hidden="true">
    <style>{DRAW_CSS}</style>
    <defs>
      <linearGradient
        id="payment-cross-gradient"
        x1="14"
        y1="12"
        x2="100"
        y2="102"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF77B2" />
        <stop offset="1" stopColor="#FFD5E9" />
      </linearGradient>
    </defs>
    <path className="cross-draw" pathLength="1" d="M20 22C38 36 60 64 94 94" {...STROKE} />
    <path
      className="cross-draw cross-draw-2"
      pathLength="1"
      d="M95 20C78 40 50 64 22 94"
      {...STROKE}
    />
  </svg>
)
